// extracted by mini-css-extract-plugin
export default {"container":"style_container__owRGA","titleFirst":"style_titleFirst__vS4vn","titleSecond":"style_titleSecond__udm6g"};